var exports = {
  "YL": "x936d19a0--a4a143--tooltip",
  "p_": "x936d19a0--a4a143--list",
  "x3": "x936d19a0--a4a143--list-item",
};

module.exports = exports;
